import React, { useState } from 'react';
import './Header.scss';
import HeaderTopMenu from './HeaderTopMenu.jsx';
import MegaMenuItem from './MegaMenuItem.jsx';
import classNames from 'classnames';

const Header = ({ headerModel, frontPageUrl, frontPageTitle }) => {
  const [selected, setSelected] = useState({ id: null, opened: false });

  const handleClick = (evt, id) => {
    evt.preventDefault();
    if (selected?.id == id && selected?.opened) {
      setSelected({ id: id, opened: false });
      return;
    }
    setSelected({ id: id, opened: true });
  }
  
  // const headerNavBotLinkClass = (id) => classNames('header-nav-bot-link', id === selected?.id && selected?.opened ? 'active' : '');

  return (
    <div className='hidden lg:flex flex-col text-[#29588C]'>
      <div className="h-[150px] flex items-center justify-between py-[13px] px-[25px] xl:px-[60px] relative z-30">
        <a href={frontPageUrl} className="bg-no-repeat bg-center bg-contain h-[28px] w-[102px] md:w-[200px] md:h-[100%]" title={frontPageTitle} style={{
          backgroundImage: "url('/Static/prod/images/logo-type.svg')"
        }}>
          <span className="sr-only">
            {frontPageTitle}
          </span>
        </a>
        <div className='flex flex-col h-full'>
          <HeaderTopMenu topMenuModel={headerModel?.topMenuModel} searchPlaceholderText={undefined} searchAccessibilityText={undefined}/>
          <ul className='flex flex-row justify-end h-full mt-4'>
            { headerModel?.megaMenuModel?.items?.map(item => 
              item.id === 750083 ? (
                <li className={classNames('text-[16px] lg:text-[18px] xl:text-[20px] ml-[10px] lg:ml-[20px] xl:ml-[32px] flex items-baseline text-blue-800')} key={item.id}>
                  <a href={item.linkUrl} className="hover:underline cursor-pointer">{item.linkTitle}</a>
                </li>
              ) : (
                <li className={classNames('text-[16px] lg:text-[18px] xl:text-[20px] ml-[10px] lg:ml-[20px] xl:ml-[32px] flex items-baseline text-blue-800', item.id === selected?.id && selected?.opened ? 'font-bold text-[#4282d0]' : '')} key={item.id}>
                  <a onClick={(evt) => handleClick(evt, item.id)} className="hover:underline cursor-pointer">{item.linkTitle}</a>
                </li>
              )
            )}
          </ul>
        </div>
      </div>
      <div className={classNames('px-[60px] overflow-hidden transition-max-height duration-300', selected?.opened ? 'max-h-[9999px]' : 'max-h-0')}>
        <MegaMenuItem item={headerModel?.megaMenuModel?.items?.find(item => item.id === selected?.id)}/>
      </div>
    </div>
  )
}

export default Header;